
import { useEffect, useState } from 'react';

// eslint-disable-next-line
import { BrowserRouter as Router ,Routes,Route, Outlet, Navigate  } from 'react-router-dom';

//toaster
import 'react-toastify/dist/ReactToastify.css'; // import first
import { Toaster } from "sonner"

//cursor
import AnimatedCursor from "react-animated-cursor"

//components
import { Home } from './components/Home/Home';
import { Login } from './components/Login/Login';
import { Otp } from './components/Otp/Otp';
import { Wallet } from './components/wallet/Wallet';
import { Deposit } from './components/deposit/Deposit';
import { Withdrawal } from './components/withdrawal/Withdrawal';
import { SuccessPageWithdrawal } from './components/withdrawal/SignalPagesWithdrawal/SuccessPage/SuccessPageWithdrawal';
import { FailPagesWithdrawal } from './components/withdrawal/SignalPagesWithdrawal/failPage/FailPagesWithdrawal';
import { BuyToken } from './components/buyToken/BuyToken';
import { ResetPassword } from './components/ResetPassword/ResetPassword';
import { ForgotPassword } from './components/ForgotPassword/ForgotPassword';
import { NotFoundPage } from './components/404Page/NotFoundPage';

//auth
import RequiredAuth from "./components/context/requireAuth"
import axios from './components/utils/axios';
import useAuth from './components/context/hook/useAuth';

import { Setting } from './components/Setting/Setting';
import { Support } from './components/support/Support';


function App() {

    const {user,auth} = useAuth()

    const [data,setData] = useState(false)

    const [data1,setData1] = useState(true)
  
    const site = async () => {
        try {
            await axios.get('/site/setting')
            .then((res)=>{
                let data = JSON.parse(res.data)
                console.log(data)
                if(data === true){
                    setData(true)
                    setData1(false)
                }else if(data === false){
                    setData(false)
                    setData1(true)
                }
            // console.log(data)
            }).catch(err=>{
                if(err){
                    setData(true)
                    setData1(false)
                }
            })
        } catch (error) {
          console.log(error)
        }
    }

    // setInterval(() => {
    //   if(data === false){
    //     console.log("checked")
    //     site()
    //   }
    // }, 60000);
    // }, 600000);

    useEffect(()=>{
        site()
        // eslint-disable-next-line
    },[])

  return (
    <>
      <div >
        { data1 &&
          (
            <div >
              <AnimatedCursor 
                innerSize={8}
                outerSize={25}
                innerScale={1}
                outerScale={1}
                outerAlpha={0}
                showSystemCursor={true}
                hasBlendMode={true}
                innerStyle={{
                  backgroundColor: 'rgba(var(--theme-color), 1)'
                }}
                outerStyle={{
                  border: '1px solid rgba(var(--theme-color), 1)'
                }}
              />

              <Router>
                <Routes>
      
                    {/* public routes */}
                    <Route path='/' element={ <Home /> }/>
                    {
                      !user && (
                        <>
                          <Route path='/login' element={  <Login /> }/>
                          <Route path='/forgot' element={ <ForgotPassword /> }/>
                          <Route path='/resetpassword' element={ user ?  <NotFoundPage  /> : <ResetPassword /> }/>
                        </>
                      )
                    }
                    {/* <Route path='/login' element={ <Login /> }/>
                    <Route path='/forgot' element={ <ForgotPassword /> }/>
                    <Route path='/resetpassword' element={ <ResetPassword /> }/> */}
                    
                    <Route path='/otp' element={ auth.otp ? <Otp /> : <NotFoundPage  /> }/>
                    {/* we want to protect thes routes */}
                    <Route element={<RequiredAuth allowedRoles={user ? user : ""}  />} >
                      <Route path='/buy/token' element={ <BuyToken /> }/>
                      <Route path='/wallet' element={<Wallet /> }/>
                      <Route path='/withdrawal' element={ <Withdrawal /> }/>
                      <Route path='/deposit' element={ <Deposit /> }/>
                      
                      <Route path='/setting' element={ <Setting /> }/>
                      <Route path='/support' element={ <Support /> }/>
                    </Route>
      
                    {/* seccess and fail pages */}
                    <Route path='/success/withdrawal' element={ <SuccessPageWithdrawal /> }/> 
                    <Route path='/fail/withdrawal' element={ <FailPagesWithdrawal /> }/> 
      
                    {/* catch all */}
                    <Route path='*' element={ <NotFoundPage  /> } />

                </Routes>
                <Toaster richColors />
              </Router>
            </div>
          ) 
        }
        { data && (
            <div>
              <h1>maintaiance</h1>
            </div>
          )
        }
      </div>
       
    </>
  );
}

export default App;
